import React, { useState } from "react";
import toast from "react-hot-toast";
import ModalProps from "@ltypes/modalProps";
import Lumeba from "@ltypes/product";
import ProductService from "@services/ProductService";
import Modal from "@components/modals/Modal/Modal";
import TextField from "@components/forms/TextField/TextField";
import Button from "@components/forms/Button/Button";
import Loader from "@components/ui/Loader/Loader";
import './AddLumebaModal.scss';
import { useTranslation } from "react-i18next";

type AddLumebaModalProps = {
    onPair: (lumeba: Lumeba) => void,
} & ModalProps;

function AddLumebaModal(props: AddLumebaModalProps) {
    const [isLoading, setLoading] = useState<boolean>(false);
    const [code, setCode] = useState<string>('');
    
    const { t } = useTranslation();

    const service = new ProductService;

    const handleAdd = () => {
        setLoading(true);
        service.pair(code).then(data => {
            toast.success(t('toast.lumeba_added'), {
                duration: 5000,
            });
            props.onPair(data.body);
        }).catch(e => {
            toast.error(e.body.message ?? 'Error');
        }).finally(() => {
            setLoading(false);
            setCode('');
            props.onHide();
        });
    };

    const handleChangeCode = (code: string) => {
        if(code.length <= 4) {
            setCode(code);
        }
    };

    const handleHide = () => {
        setCode('');
        setLoading(false);
        props.onHide();
    };

    return (
        <Modal className="modal-addlumeba" visible={props.visible} onHide={handleHide}>
            <div className="row">
                <div className="col-12">
                    <h3>{t('modal.add_lumeba')}</h3>
                </div>
                <div className="col-12">
                    {isLoading ? (
                        <Loader size="2.5rem" noMargin/>
                    ) : (
                        <TextField value={code} placeholder="____" onChange={handleChangeCode}/>
                    )}
                </div>
            </div>
            <div className="row mt-3 gx-2 justify-content-end">
                <div className="col-auto">
                    <Button className="secondary" onClick={handleHide}>{t('text.cancel')}</Button>
                </div>
                <div className="col-auto">
                    <Button disabled={code.length !== 4 || isLoading} onClick={handleAdd}>{t('text.add')}</Button>
                </div>
            </div>
        </Modal>
    );
}

export default AddLumebaModal;
